export const PageLoaderStyle = {
  LoadContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100vh",
  
    backgroundColor: "white",
  },
  LoadBox: {
    height: "8rem",
    width: "8rem",
    borderRadius: "1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: 5,
    backgroundImage: "linear-gradient(45deg, #2196f3, #e3f2fd)",
    backdropFilter: "blur(45px)",
  },
};
